// extracted by mini-css-extract-plugin
export var layoutContainer = "_50-0";
export var layoutContainerNoRounding = "_50-6";
export var layoutContainerOpen = "_50-5";
export var layoutContainerResizing = "_50-1";
export var mainContent = "_50-2";
export var resizeDivider = "_50-3";
export var slidePanel = "_50-4";